import authReducer from "./slice/auth.slice";
import { configureStore } from "@reduxjs/toolkit";

import userReducer from "./slice/user.slice";
import commonReducer from "./slice/common.slice";
import titleRouteReducer from "./slice/titleRoute.slice";

import rootSaga from "./saga/root.saga";
import createSagaMiddleware from "redux-saga";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        common: commonReducer,
        titleRoute: titleRouteReducer,
    },
    devTools: true,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
